
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { vuex } from "@/store";
import router from "@/router";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// import { l3draggable, l3droppable } from "@/directives/l3dragDrop";
// component
import NumberInput from "@/components/Shared/NumberInput.vue"
import AvatarWithDnD from "../Shared/AvatarWithDnD.vue";
import ImageWithDnD from "../Shared/ImageWithDnD.vue";
import TusFileDrop from "../Shared/TusFileDrop.vue";
import CompImage from "../ExerciseComponents/CompImage.vue";
import SimpleMessageBox from "../Shared/SimpleMessageBox.vue";
// interfaces
import { ExBundleVM } from "@/interfaces/ExBundleAssignmentGroupVM";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { FileDetailsVm } from "@/interfaces/FileDetailsVm";
import { BundleCategoriesVm } from "@/interfaces/BundleCategoriesVm";

//const auth = namespace("auth");
const globals = namespace("globals");

@Component({
  components: {
    CompImage,
    TusFileDrop,
    NumberInput,
    AvatarWithDnD,
    ImageWithDnD,
    SimpleMessageBox,
  }
})
export default class EditBundleDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop() bundle!: ExBundleVM;

  // @globals.Getter selectedBundle!: ExBundleVM;

  isBusy = false;
  formValid = false;
  busyOnSave = false;
  editBundle: ExBundleVM | null = null;
  bundleCategories: BundleCategoriesVm[] | null = null;
  bundleFileList: FileDetailsVm[] | null = null;
  selectedCourseImgFile: FileDetailsVm | null = null;
  selectedCourseLogoFile: FileDetailsVm | null = null;
  enableTestRepetition1 = false;
  enableTestRepetition2 = false;
  testRepetition1 = 1;
  testRepetition2 = 2;
  showRemoveTranslationConfirm = false;
  pendingRemoveLanguageCode = '';

  // @auth.Getter isAdmin: any;
  // @auth.Getter isOrgAdmin: any;
  // @auth.Getter isGroupAdmin: any;

  $refs!: {
    formElement: HTMLFormElement;
  };

  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      this.editBundle = null;
      if (this.bundle?.id) {
        this.editBundle = _.cloneDeep(this.bundle);
        this.editBundle.createdWithContentCreator = true; // Ensure this is set for new bundles
        if (this.editBundle.masterLanguageCode == null || this.editBundle.masterLanguageCode === "") {
          this.editBundle.masterLanguageCode = "de-DE";
        }
        if (this.editBundle.testReassignDelayInDays && this.editBundle.testReassignDelayInDays !== "-") {
          const parts = this.editBundle.testReassignDelayInDays.split(",");
          if (parts.length > 0) {
            this.enableTestRepetition1 = true;
            this.testRepetition1 = parseInt(parts[0], 10);
          }
          if (parts.length > 1) {
            this.enableTestRepetition2 = true;
            this.testRepetition2 = parseInt(parts[1], 10);
          }
        } else {
          this.enableTestRepetition1 = false;
          this.enableTestRepetition2 = false;
        }
      }
      else {
        this.editBundle = <any>{ id: 0, createdWithContentCreator: true, name: "", masterLanguageCode: "de-DE", translationLanguageCodes: [], nameTranslations: {}, category1: "", category2: "", category3: "", guid: "", sequentialModuleProcessing: false };
        this.generateGuid();
      }

      // Ensure nameTranslations exists and has entries for all translation language codes
      if (!this.editBundle!.nameTranslations) {
        this.editBundle!.nameTranslations = {};
      }
      if (this.editBundle!.translationLanguageCodes) {
        this.editBundle!.translationLanguageCodes.forEach(langCode => {
          if (!this.editBundle!.nameTranslations![langCode]) {
            this.editBundle!.nameTranslations![langCode] = '';
          }
        });
      }

      await this.updateView();

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    this.syncedShowDialog = false;
    clearAllBodyScrollLocks();
  }

  async updateView() {
    // await this.$refs.formElement.validate();
    await this.getBundleCategories();
    await this.getBundleFiles();
  }

  async getBundleCategories() {
    // let params: ParamDictionary = { dictionary: {}};
    this.bundleCategories = await rest.url("contentManager/getBundleCategories").get();
  }

  get languageOptions() {
    return this.$globalHelper.euLanguageOptions;
  }

  get availableTranslationLanguages() {
    const masterCode = this.editBundle?.masterLanguageCode || '';
    const existingCodes = this.editBundle?.translationLanguageCodes || [];
    return this.languageOptions.filter(
      lang => lang.value !== masterCode && !existingCodes.includes(lang.value)
    );
  }

  getLanguageText(code: string): string {
    const lang = this.languageOptions.find(l => l.value === code);
    return lang ? lang.text : code;
  }


  getFlagUrlForLanguage(code: string): string {
    const lang = this.languageOptions.find(l => l.value === code);
    if (lang?.countryCode) {
      return this.$globalHelper.getFlagUrl(lang.countryCode);
    }
    return '';
  }

  addTranslationLanguage(langCode: string) {
    if (!this.editBundle) return;
    if (!this.editBundle.translationLanguageCodes) {
      this.editBundle.translationLanguageCodes = [];
    }
    if (!this.editBundle.translationLanguageCodes.includes(langCode)) {
      this.editBundle.translationLanguageCodes.push(langCode);
      // Initialize nameTranslations entry
      if (!this.editBundle.nameTranslations) {
        this.editBundle.nameTranslations = {};
      }
      this.editBundle.nameTranslations[langCode] = '';
    }
  }

  removeTranslationLanguage(langCode: string) {
    this.pendingRemoveLanguageCode = langCode;
    this.showRemoveTranslationConfirm = true;
  }

  confirmRemoveTranslationLanguage() {
    if (!this.editBundle || !this.editBundle.translationLanguageCodes) return;
    const langCode = this.pendingRemoveLanguageCode;

    // Remove from translationLanguageCodes array
    const index = this.editBundle.translationLanguageCodes.indexOf(langCode);
    if (index > -1) {
      this.editBundle.translationLanguageCodes.splice(index, 1);
    }

    // Remove from nameTranslations dictionary
    if (this.editBundle.nameTranslations && this.editBundle.nameTranslations[langCode] !== undefined) {
      delete this.editBundle.nameTranslations[langCode];
    }

    this.pendingRemoveLanguageCode = '';
  }

  get cat1suggestion()
  {
    if (!this.bundleCategories)
      return [];

    const cat1list = new List(this.bundleCategories)
      .select(x => x.category1)
      .distinct()
      .toArray();

    return cat1list;
  }

  get cat2suggestion()
  {
    if (!this.bundleCategories || !this.editBundle)
      return [];

    const cat2list = new List(this.bundleCategories)
      .where(x => x.category1 == this.editBundle!.category1)
      .select(x => x.category2)
      .distinct()
      .toArray();

    return cat2list;
  }

  get cat3suggestion()
  {
    if (!this.bundleCategories || !this.editBundle)
      return [];

    const cat3list = new List(this.bundleCategories)
      .where(x => x.category1 == this.editBundle!.category1 && x.category2 == this.editBundle!.category2)
      .select(x => x.category3)
      .distinct()
      .toArray();

    return cat3list;
  }

  async getBundleFiles() {
    if (this.editBundle == null || this.editBundle.id == 0)
      return;

    this.bundleFileList = null;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] = this.editBundle!.id.toString();
    params.dictionary!["LocalPath"] = this.editBundle!.localPath!;
    params.dictionary!["Type"] = "Image";
    this.bundleFileList = await rest.url("contentManager/getBundleFiles").post(params);
  }

  // Card Image methods
  onNewFileDropped(fileDetails: FileDetailsVm) {
    if (fileDetails.fileType != "Image") {
      this.$store.commit("ux/SB_FAILURE", {
        message: "Bei dieser Datei handelt es sich nicht um ein Bild.",
        timeout: 0
      });
      return;
    }
    this.editBundle!.cardImage = fileDetails.filePath;
  }

  // onDeleteImage() {
  //   this.editBundle!.cardImage = "";
  //   this.selectedCourseImgFile = null;
  // }

  async onMediaFileUploaded(response: any): Promise<void> {
    if (!response.success) {
      this.$store.commit("ux/SB_FAILURE", {
        message: response.message,
        timeout: 0
      });
      return;
    }

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["OldFilePath"] = this.editBundle!.cardImage ?? "";
    params.dictionary!["UploadedFileName"] = response.fileName!;
    params.dictionary!["RelativePath"] = "";
    params.dictionary!["BundleId"] = this.editBundle!.id.toString();
    await rest.url("contentManager/moveFileToBundleDir").post(params)
      .then(async (response) => {
        if (!response) {
          return;
        }
        // console.log("response", response);
        this.editBundle!.cardImage = response;
      })
      .catch(err => {
      })
      .finally(() => {
        this.isBusy = false;
      });
  }

  onCourseImgFileSelect(file: FileDetailsVm) {
    this.selectedCourseImgFile = file;
    this.editBundle!.cardImage = file.filePath;
  }

  onCourseLogoFileSelect(file: FileDetailsVm) {
    this.selectedCourseLogoFile = file;
    this.editBundle!.image = file.filePath;
  }

  onCancel() {
    const form = (this.$refs.formElement as any) || null;
    if (form) {
      try {
        if (typeof form.resetValidation === 'function') {
          form.resetValidation();
        }
        if (typeof form.reset === 'function') {
          form.reset();
        }
      } catch (err) {
        console.warn('Error resetting form before close', err);
      }
    }
    this.formValid = false;
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
    this.editBundle = null;
  }

  // Add method to update model immediately from combobox input
  onComboboxKeyup(event: KeyboardEvent, field: 'category1'|'category2'|'category3') {
    const target = event.target as HTMLInputElement | null;
    if (!this.editBundle || !target) return;
    (this.editBundle as any)[field] = target.value;
  }

  async onSave() {
    await this.$nextTick();
    const form = (this.$refs.formElement as any) || null;
    if (!form || typeof form.validate !== 'function') {
      // console.warn('Form ref not available; aborting save.');
      return;
    }
    let isValid = false;
    try {
      isValid = await form.validate();
    } catch (err) {
      // console.warn('Validation threw an error', err);
      if (typeof form.resetValidation === 'function') form.resetValidation();
      return;
    }
    if (!isValid) {
      // console.log('Form validation failed');
      return;
    }

    this.busyOnSave = true;

    // Prepare test reassign delay
    if (this.enableTestRepetition1 || this.enableTestRepetition2) {
      if (this.enableTestRepetition1) {
        this.editBundle!.testReassignDelayInDays = `${this.testRepetition1}`;
      }
      if (this.enableTestRepetition2) {
        this.editBundle!.testReassignDelayInDays += `,${this.testRepetition2}`;
      }
    } else {
      this.editBundle!.testReassignDelayInDays = "-";
    }

    await rest.url("contentManager/addOrUpdateBundle")
      .post(this.editBundle)
      .then((response) => {
        if (!response) return;

        vuex.globals.setBundle(response);
        // this.$refs.formElement.reset();
        if (this.editBundle?.id == 0)
          this.$emit('added:EditBundleDlg');
        else
          this.$emit('changed:EditBundleDlg');
        this.syncedShowDialog = false;
      })
      .finally(() => {
        this.busyOnSave = false;
      });
  }

  async generateGuid() {
    if (!this.editBundle || this.editBundle.guid)
      return;

    this.editBundle.guid = await rest.url("contentManager/getNewGuid").get();
  }

  bundleNameRules = [
    (v: string) => !!v || "Eingabe erforderlich",
    (v: string) => (v && v.length >= 2) || "Name zu kurz",
    (v: string) => (v && v.length <= 100) || "Name zu lang"
  ];

  certificateTitleRules = [
    (v: string) => (!v || v && v.length <= 100) || "Name zu lang"
  ];

  certificateSummaryRules = [
    (v: string) => (!v || v && v.length <= 300) || "Beschreibung zu lang"
  ];

  catNameRules = [
    (v: string) => !!v || "Eingabe erforderlich",
    (v: string) => (v && v.length >= 1) || "Name für Kategorie zu kurz",
    (v: string) => (v && v.length <= 100) || "Name für Kategorie zu lang"
  ];
}
